import { first } from '@lumapps/utils/iterable/first';
import { Editor, Element, Node, type BaseEditor, type Path } from '@lumapps/wrex/slate';
import { getNode } from '@lumapps/wrex/slate/utils/getNode';

// Check that column is empty if no text and no void blocks
export const isColumnEmpty = (editor: BaseEditor, columnPath: Path) => {
    const hasVoidDescendant = first(
        Editor.nodes(editor, {
            at: columnPath,
            match: (n) => Element.isElement(n) && editor.isVoid(n),
        }),
    );
    const node = getNode(editor, columnPath)?.[0];

    const isNodeEmpty = node ? Node.string(node).trim().length === 0 : true;
    return hasVoidDescendant ? false : isNodeEmpty;
};
